<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="domain" label="领域" prop="domain">
                    <a-select v-if="is_new" v-model="record.domain" style="width: 80px">
                        <a-select-option value="001">前台</a-select-option>
                        <a-select-option value="002">中台</a-select-option>
                        <a-select-option value="003">开放</a-select-option>
                        <a-select-option value="004">基础</a-select-option>
                    </a-select>
                    <span v-else>{{record.domain}}</span>
                </a-form-model-item>

                <a-form-model-item ref="version" label="版本号" prop="version">
                    <a-select v-if="is_vue_task" v-model="record.version" placeholder="" style="width: 80px">
                        <a-select-option value="V3.0"> V3.0 </a-select-option>
                        <a-select-option value="V5.0"> V5.0 </a-select-option>
                    </a-select>
                    <span v-else>{{record.version}}</span>
                </a-form-model-item>

                <a-form-model-item ref="classname" label="类名" prop="classname">
                    <a-input v-if="is_vue_task" v-model="record.classname" @click="handleSelectClass" />
                    <span v-else>{{record.classname}}</span>
                    <classSelecter ref="classSelecterID" @onModalHide="(val)=>{this.record.classname = val ? val : this.record.classname}"></classSelecter>
                </a-form-model-item>

                <a-form-model-item v-if="record.domain == '003'" ref="servicekey" label="servicekey" prop="servicekey">
                    <a-input v-if="is_vue_task" v-model="record.servicekey" />
                    <span v-else>{{record.servicekey}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.domain != '003'" ref="path" label="path" prop="path">
                    <a-input v-if="is_vue_task" v-model="record.path" />
                    <span v-else>{{record.path}}</span>
                </a-form-model-item>

                <a-form-model-item v-if="record.domain != '003'" ref="sign" label="sign" prop="sign">
                    <a-input v-if="is_vue_task" v-model="record.sign" />
                    <span v-else>{{record.sign}}</span>
                </a-form-model-item>

                <a-form-model-item ref="module" label="模块编码" prop="module">
                    <a-input v-if="is_vue_task" v-model="record.module" />
                    <span v-else>{{record.module}}</span>
                </a-form-model-item>

                <a-form-model-item ref="remark" label="备注" prop="remark">
                    <a-input v-if="is_vue_task" v-model="record.remark" />
                    <span v-else>{{record.remark}}</span>
                </a-form-model-item>



                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import classSelecter from './classSelecter.vue'
const m_title = {
    'add_processor':'新增处理器映射配置',
    'detail_processor':'查看处理器映射配置',
    'edit_processor':'编辑处理器映射配置',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                classname: [
                    { required: true, message: ' 请输入类名 ', trigger: 'blur' },
                ],
                domain:[
                    { required: true, message: ' 请输处理器配置编码 ', trigger: 'blur' },

                ],
                servicekey:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                path:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
                sign:[
                    { required: true, message: ' 必传字段 ', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                domain:'001',
                classname:'',
                servicekey:'',
                path:'',
                sign:'',
                module:'',
                remark:'',
                version:'V3.0'
            }
        };
    },
    components:{
        classSelecter
    },
    methods: {
        handleSelectClass(){
            this.$refs.classSelecterID.init(this.record.domain);
        },
        handleOk() {
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'edit_processor'){
                        that.$store
                            .dispatch({
                                type: "servicekey/processorEdit",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add_processor'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "servicekey/processorAdd",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.domain = '001'
        },

        getDetail(id){
            this.$store.dispatch({
                type: "servicekey/processorQuery",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    }
                }
            });
        }
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_processor";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_processor'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
